// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id='customer-deposit-accounts-stop-order' class="box">
  <sub-header header="'Create stop order'"></sub-header>

    <!-- Product information -->
    <!-- TODO = this should be extracted as component -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">
          {{\$ctrl.account.productName}}
        </span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value"
              ng-class="{'currency--positive': \$ctrl.account.balance > 0, 'currency--negative': \$ctrl.account.balance < 0}">
          {{\$ctrl.account.balance | nxCurrency}}
        </span>
      </div>
    </div>

    <br/>

    <form name="\$ctrl.form">
      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Check number</td>
          <td>
            <input
              required
              name="checkNumber"
              type="text"
              ui-mask="9999999999"
              ng-model="\$ctrl.checkNumber"/>
          </td>
          <td></td>
        </tr>
        <tr ng-if="\$ctrl.isPchcDirectClearing">
          <td></td>
          <td>Account number</td>
          <td>
            <input
              required
              type="text"
              minlength="12"
              maxlength="12"
              ng-model="\$ctrl.accountNumber"/>
          </td>
        </tr>
        <tr ng-if="!\$ctrl.isPchcDirectClearing">
          <td></td>
          <td>Depository account</td>
          <td>
            <selectize
              required
              options="\$ctrl.depositoryAccounts"
              config="\$ctrl.depositoryAccountSelectConfig"
              ng-model="\$ctrl.depositoryAccountId"
              ng-change="\$ctrl.onDepositoryAccountChange()">
            </selectize>
          </td>
          <td></td>
        </tr>
        <tr ng-if="!\$ctrl.isPchcDirectClearing">
          <td></td>
          <td>Depository account number</td>
          <td>
            <input
              disabled
              required
              type="text"
              minlength="12"
              maxlength="12"
              ng-model="\$ctrl.depositoryAccount.accountNumber"/>
          </td>
          <td></td>
        </tr>
        <tr ng-if="!\$ctrl.isPchcDirectClearing">
          <td></td>
          <td>Depository account BRSTN</td>
          <td>
            <input
              disabled
              required
              type="text"
              minlength="9"
              maxlength="9"
              ui-mask="999999999"
              ng-model="\$ctrl.depositoryAccount.brstn"/>
          </td>
          <td></td>
        </tr>
        <tr ng-if="\$ctrl.fee">
          <td></td>
          <td>Fee</td>
          <td>
            <cash ng-model="\$ctrl.fee"
                  ng-disabled="true"></cash>
          </td>
          <td>
            <label class="checkbox misc-transaction__table-checkbox">
              <input type="checkbox"
                     ng-model="\$ctrl.overrideFee">Override
            </label>
          </td>
        </tr>
        <tr ng-if="\$ctrl.overrideFee">
          <td></td>
          <td>Fee override</td>
          <td>
            <cash ng-model="\$ctrl.feeOverrideAmount"
                  min="0"
                  required></cash>
          </td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Remarks</td>
          <td>
            <input type="text"
                   ng-model="\$ctrl.remarks"
                   ng-maxlength="1024"
                   ng-required="false">
          </td>
          <td></td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <button class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button class="btn btn-danger"
                ng-click="\$ctrl.createStopOrder()"
                ng-disabled="\$ctrl.form.\$invalid">
          Create
        </button>
      </div>
    </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/stop-order/stop-order.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;